module.exports = {
  WinName: 'Print',
  TemplateName: 'Document',
  OK: 'Ok',
  Cancel: 'Cancel',
  QueryTemplateFailed: 'Failed to load template.',
  Tips: 'Tips',
  PlsSelectTemplate: 'Pls select a document.',
  Copy: 'Copy',
  TemplateTypes: 'Template Types',
  EmailTemp: 'E - mail Templates',
  viewV3: 'V3 Templates',
  inputTemplateName: 'Template Name Input',
  notFoundTemplate: 'No template of corresponding type found, please add template first!',
  batchPrintMore: 'Batch printing data amount exceeds {} (system upper limit), the system cannot load, please contact online customer service!',
  noSchemaType: 'Schematype not maintained!',
  printMore: 'If the number of printed records exceeds 100, the loading time may be long. Do you want to continue printing?',
  notFoundTemplateFromData: 'Template [{}] not found, please check the template!',
  notEmptyTemplateName: 'Template name cannot be empty!',
  hasFoundTemplateName: 'Template name already exists!',
  attachmentLarge: 'The content of the attachment is too large',
  smtpServerError: 'SMTP server error!',
  unConnectSmtp: 'Unable to connect to the SMTP server!',
  notFoundFile: 'The system cannot find the specified file!',
  fileSendError: 'Error sending file!',
  attachmentTemplateError: 'Error in attachment template!',
  sendEmailSuccess: 'Email sent successfully!'
}
